<template>
  <div
    class="environment-badge"
    v-if="formattedEnvironment(environment) != null"
    :class="`environment-badge--${environment}`"
  >
    <span class="label-text">
      <span class="environment-badge__prefix">Kundservice&nbsp;</span>
      <span class="label-environment">{{
        formattedEnvironment(environment)
      }}</span>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { currentEnvironment } from "@/common/utils/currentEnvironment";

const environment = currentEnvironment();

export default defineComponent({
  data() {
    return {
      environment: "localhost",
    };
  },
  mounted() {
    this.environment = environment;
  },
  methods: {
    formattedEnvironment(env: string) {
      if (env === "localhost") return "Local";
      if (env === "dev") return "Dev";
      if (env === "test") return "Test";
      if (env === "uat") return "UAT";
      if (env === "prod") return null;
      if (env === "unknown") return "Okänd miljö";
      return env;
    },
  },
});
</script>

<style lang="css">
.environment-badge {
  display: inline-flex;
  border-bottom-right-radius: 16px;
  padding: 0px 22px 0px 18px;
  color: #152745;
  font-weight: bold;
  font-size: 13px;
  line-height: 1;
}

.environment-badge--localhost {
  background-color: #dcdcdc;
}
.environment-badge--dev {
  background-color: #f1d4e1;
}
.environment-badge--test {
  background-color: #ed8c00;
}
.environment-badge--uat {
  background-color: #212b46;
  color: #ffffff;
}
.environment-badge--prod {
  background-color: #e15242;
  color: #ffffff;
}
</style>
